module.exports = __webpack_public_path__ + "static/independent-banker-f2f02a50d17e24a858c80eaf0da0c175.png";